import React, { useState, useEffect, useRef } from "react";
// import Nav from "../NavBar/Nav";
import NavNewDark from "../NavBar/NavNewDark";
import NavNew from "../NavBar/NavNew";
import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Document, Page, pdfjs } from "react-pdf";
import axios from "axios";
import base_url from "../../api/bootapi";
import attachmenturl from "../../api/attachmenturl";
import { useDispatch, useSelector } from "react-redux";
import { Collapse, CardBody, Card } from "reactstrap";
import { getTour, selectTour } from "../Reducers/tourSlice";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import moment from "moment";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import Swal from "sweetalert2";
import { width } from "@mui/system";
import bannerbackground from "../../assets/bannerbackground.jpg";
import NoImg from "../../assets/NoImagePlaceholder.png";
import Nav from "../NavBar/Nav";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { IconMapPin, IconCalendar, IconWorld, IconChevronRight } from "@tabler/icons-react";

// ... inside your map function:
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function VacationList() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm();

  const [backdropopen, setbackdropopen] = useState(false);

  const navigate = useNavigate();
  // const params = useParams();
  const [vacationList, setVacationList] = useState([]);

  // const vacationType = params.vacation_type || null;

  const location = useLocation();
  const vacationType =
    location.pathname.split("/").filter(Boolean).pop() || null;

  useEffect(() => {
    getAllTourList();
  }, [vacationType]);

  const getImageLink = async (file) => {
    const primaryImg = file;
    const fullURL = `${attachmenturl}${primaryImg}`;

    const isPdf = /\.pdf$/i.test(primaryImg);
    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(primaryImg);
    console.log("Checking ===================> ");
    console.log(isPdf, isImage);

    let imgUrl = null;
    if (isPdf) {
      imgUrl = await pdfToImage(fullURL);
    } else if (isImage) {
      imgUrl = fullURL;
    }

    return imgUrl;
  };

  const pdfToImage = async (pdfUrl) => {
    const loadingTask = pdfjs.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    const imageUrls = [];

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: 1.5 });

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      await page.render(renderContext).promise;

      // Convert canvas to data URL
      const imageUrl = canvas.toDataURL();
      imageUrls.push(imageUrl);
    }

    return imageUrls; // Array of base64 image strings
  };

  const getAllTourList = () => {
    setbackdropopen(true);
    const vacation_type =
      vacationType === "summer-vacation"
        ? "Summer"
        : vacationType === "winter-vacation"
          ? "Winter"
          : null;
    axios
      .get(
        `${base_url.api1}/tourapp/vacation_list?vacation_type=${vacation_type}`
      )
      .then(async (response) => {
        console.log("Vacation details", response.data.vacation);
        const vacationData = response.data.vacation || [];

        // Add preview image to each vacation
        const vacationWithImages = await Promise.all(
          vacationData.map(async (vacation) => {
            const img = await getImageLink(vacation.primary_image);
            return {
              ...vacation,
              primary_image: Array.isArray(img) ? img[0] : img,
            };
          })
        );

        setVacationList(vacationWithImages);
        setbackdropopen(false);
      })
      .catch((err) => {
        setVacationList([]);
        setbackdropopen(false);
      });
  };

  return (
    <div style={{ backgroundColor: "#F5F6FA" }}>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />

        <div className="container">
          <div
            className="page-head d-flex justify-content-between pt-4 pb-4"
            style={{ marginTop: "1.3rem" }}
          >
            <ul className="breadcrums">
              <Link to="/" className="b-link">
                Home
              </Link>
              <span className="s_span ">&raquo;</span>
              <Link to="#" className="b-link">
                Linsoa Tours
              </Link>
              <span className="s_span ">&raquo;</span>
              <Link to="#" className="b-link active">
                {vacationType === "summer-vacation"
                  ? "Summer "
                  : vacationType === "winter-vacation"
                    ? "Winter "
                    : ""}
                Vacations
              </Link>
            </ul>
          </div>

          <div className="vacation-list-wrapper">
            {vacationList.length > 0 &&
              vacationList.map((vacation, index) => {
                return (

                  <div key={index} className="vacation-card card border-0 shadow-sm rounded-4 overflow-hidden h-100 transition-all hover-lift">
                    {/* Image Header with Badge */}
                    <div className="position-relative">
                      <span className="badge position-absolute top-0 start-0 m-3 px-3 py-2 rounded-pill bg-white text-dark shadow-sm">
                        <IconWorld size={14} className="me-1" />
                        {vacation.domestic ? "Domestic USA" : "International"}
                      </span>
                      <img
                        src={vacation.primary_image || NoImg}
                        alt={vacation.vacation_name}
                        className="card-img-top"
                        style={{ height: "280px", cursor: "pointer" }}
                        onClick={() => navigate(`/${vacationType}/${vacation.url_name}`)}
                      />
                    </div>

                    {/* Card Body */}
                    <div className="card-body p-4">
                      <h5 className="card-title fw-bold mb-2">{vacation.vacation_name}</h5>
                      <p className="card-text text-muted small mb-4 line-clamp-2">
                        {vacation.vacation_description}
                      </p>

                      {/* Date Details using Tabler Icons */}
                      <div className="d-flex flex-column gap-2 text-dark">
                        <div className="d-flex align-items-center gap-2 small">
                          <IconCalendar size={16} className="text-primary" />
                          <span>
                            {moment(vacation.vacation_start_date).format("MMM DD, YYYY")} - {moment(vacation.vacation_end_date).format("MMM DD, YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Footer Action */}
                    <div className="card-footer bg-transparent border-0 p-4 pt-0">
                      <button
                        onClick={() => navigate(`/${vacationType}/${vacation.url_name}`)}
                        className="btn btn-outline-primary w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
                      >
                        View Details <IconChevronRight size={16} />
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>

          {vacationList.length === 0 && backdropopen === false && (
            <div className="text-center" style={{ padding: "50px 0" }}>
              <h5>No Vacations</h5>
            </div>
          )}
        </div>
        <FooterNew />
      </React.Fragment>
    </div>
  );
}
